import React, { Component } from 'react';
import { TimelineLite } from 'gsap';

class Plan extends Component {

	numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace('.00', '');
	}

	handleClick() {
		if (this.clickMsg.classList.contains('open')) {
			this.hideClickMsg();
		} else {
			this.showClickMsg();
		}
	}

	showClickMsg() {
		let tl = new TimelineLite();
		tl.set(this.clickMsg, {height: 0});
		tl.set(this.bottom, {borderRadius: 0});
		tl.add(() => {
			this.clickMsg.classList.add('open');
		});
		tl.to(this.clickMsg, 0.25, {height: '50px'});
	}

	hideClickMsg() {
		let tl = new TimelineLite();
		tl.add(() => {
			this.clickMsg.classList.remove('open');
		});
		tl.to(this.clickMsg, 0.25, {height: 0});
		tl.set(this.bottom, {borderRadius: '0 0 10px 10px'});
	}

	render() {
		return (
			<div className="plan" onClick={this.handleClick.bind(this)}>
				<div className="inner">
					<div className="top">{this.props.title}</div>
					<div className="bottom" ref={el => this.bottom = el}>
						{(this.props.image ?
							<div className="img-wrap">
								<img src={'/images/' + this.props.image} alt="" />
							</div>
							: '')}
						<p>{this.props.speed}<br />Unlimited downloads</p>
						<h3>Monthly fee: ${this.numberWithCommas(this.props.monthlyFee)}</h3>
						<p>Activation Fee: ${this.numberWithCommas(this.props.activationFee)}</p>
					</div>
				</div>
				<div className="click-msg" ref={el => this.clickMsg = el} style={{height: 0}}>
					<span>Like this plan? Call us on <a href="tel:1300393835">1300 393 835</a></span>
				</div>
			</div>
		);
	}

}

export default Plan;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Plan.js